import React, { useEffect, useState } from "react";

/* -------- packages -------- */
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from "react-redux";
import { Container } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
/* -------- ------- -------- */

/* -------- intern functions -------- */
import { clearDashboardSuccess, clearDepartmentErrors, deleteDepartmentRequest, fetchAgenciesRequest, fetchDepartmentsRequest, fetchSectorsRequest, openEditPage, openEditPageDepartment } from "../../store/actions";
/* -------- ------- -------- */

/* -------- components -------- */
import TableContainer from "../../components/ui/List/TableContainer";
import Breadcrumb from "../../components/ui/Breadcrumbs";
import ErrorHandler from "../../components/ui/Error/ErrorHandler";
/* -------- ------- -------- */

export default function Departments () {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  const parameters = useSelector(state => state.Parameters);
  document.title = `${t('departments')} | ${parameters.appName}`; //meta title

  const {departments, departmentAdded, errorDepartement} = useSelector(state => state.Departments);
  const sectors = useSelector(state => state.Sectors.sectors);
  const agencies = useSelector(state => state.Agencies.agencies);

  const [formattedSectors, setFormattedSectors] = useState([]);
  const [formattedAgencies, setFormattedAgencies] = useState([]);

  useEffect(() => {
    dispatch(fetchDepartmentsRequest());
    dispatch(fetchSectorsRequest());
    dispatch(fetchAgenciesRequest());
  }, []);

  useEffect(() => {
    if (sectors) {
      let newSectors = sectors.map((sector) => {
        return {
          id: sector.id,
          label: sector.lib
        }
      });
      setFormattedSectors(newSectors);
    }
  }, [sectors]);

  useEffect(() => {
    if (agencies) {
      let newAgencies = agencies.map((agency) => {
        return {
          id: agency.id,
          label: agency.lib
        }
      });
      setFormattedAgencies(newAgencies);
    }
  }, [agencies]);

  ErrorHandler(errorDepartement, clearDepartmentErrors);

  useEffect(() => {
    if (departmentAdded) {
      toast.success(t('dataSaved'));
      dispatch(clearDashboardSuccess());
    }
  }, [departmentAdded]);

  // Configuration des colonnes
  const columnConfig = [
    { key: 'id', type: 'text' },
    { key: 'lib', type: 'text' },
    { key: 'code', type: 'text', isDisabled: true },
    { key: 'sectorLib', type: 'text' },
    { key: 'agencyLib', type: 'text' },
    { key: 'createdAt', type: 'date' },
    { key: 'updatedAt', type: 'date' },
  ];

  // Configuration des filtres
  const filterConfig = [
    { key: 'sectorLib', type: 'select', options: formattedSectors },
    { key: 'agencyLib', type: 'select', options: formattedAgencies },
  ];

  return (

      <div className="page-content">
        <Container fluid>
          <Breadcrumb breadcrumbItem={t("departments")}/>
          
          <TableContainer
            columnConfig={columnConfig}
            filterConfig={filterConfig}
            data={departments}
            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            theadClass="table-light"
            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            pagination="pagination"
            divClassName="table-responsive"
            isBordered={true}
            isPagination={true}
            isGlobalFilter={true}
            buttonClass="btn btn-primary btn-rounded waves-effect waves-light addContact-modal mb-2"
            buttonName="newDepartment"
            prefListName="department"
            totalKpi={{label: 'numberOfDepartments', icon: 'mdi mdi-crosshairs'}}
            isAddButton={false}
            isNewButton={false}
            editFunction={openEditPageDepartment} 
            withDelete={false}
            defaultSortColumn={'lib'}
            defaultSortDirection={'asc'}
            noCheckbox={true}
          />
        </Container>
        <ToastContainer />
      </div>

  );
};

